import React from "react";
import {useNavigate} from "react-router-dom";
import {Button} from "reactstrap";
import ProtectedContent from "../../components/protectedContent";

const ReportHeader = ({activeTab = "1"}) => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    if (activeTab === "1") {
      navigate("/app/reports/add-template");
    } else if (activeTab === "2") {
      navigate("/app/reports/add-report");
    }
  };

  const getButtonText = () => {
    if (activeTab === "1") {
      return "ADD TEMPLATE";
    } else if (activeTab === "2") {
      return "ADD REPORT";
    }
  };

  const customFallback = () => {
    return <div style={{marginTop: "20px"}}></div>;
  };

  return (
    <ProtectedContent
      perms={[activeTab === "1" ? "add_reporttemplate" : "add_report"]}
      showFallback
      customFallback={customFallback}
    >
      <div className="d-flex justify-content-md-end mb-2 mb-sm-0">
        <Button
          className="btn_common roboto-bold"
          onClick={handleAddClick}
          style={{zIndex: "10"}}
          data-cy="addReport"
        >
          {getButtonText()}
        </Button>
      </div>
    </ProtectedContent>
  );
};

export default ReportHeader;
